// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import Filters__DatesRangeController from "./filters/dates_range_controller"
application.register("filters--dates-range", Filters__DatesRangeController)

import Forms__ConfigurationCalendarController from "./forms/configuration_calendar_controller"
application.register("forms--configuration-calendar", Forms__ConfigurationCalendarController)

import Forms__CustomFormRawDataController from "./forms/custom_form_raw_data_controller"
application.register("forms--custom-form-raw-data", Forms__CustomFormRawDataController)

import Forms__DashboardWidgetsController from "./forms/dashboard_widgets_controller"
application.register("forms--dashboard-widgets", Forms__DashboardWidgetsController)

import Forms__DeftaCustomOneController from "./forms/defta_custom_one_controller"
application.register("forms--defta-custom-one", Forms__DeftaCustomOneController)

import Forms__FlowConfigurationFrequencyController from "./forms/flow_configuration_frequency_controller"
application.register("forms--flow-configuration-frequency", Forms__FlowConfigurationFrequencyController)

import Forms__FlowConfigurationsController from "./forms/flow_configurations_controller"
application.register("forms--flow-configurations", Forms__FlowConfigurationsController)

import Forms__ImportExportProfileController from "./forms/import_export_profile_controller"
application.register("forms--import-export-profile", Forms__ImportExportProfileController)

import Forms__PrepareFlowConfigurationsController from "./forms/prepare_flow_configurations_controller"
application.register("forms--prepare-flow-configurations", Forms__PrepareFlowConfigurationsController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)
